export const reportFormatType = {
  DAILY: 'daily',
  MONTHLY: 'monthly',
};

export const parkingStatus = {
  OCCUPIED: 'occupied',
  VACANT: 'vacant',
};

export const buttonLabel = {
  OPEN_MAP: 'Open Map',
  DOWNLOAD: 'Download',
  REFRESH: 'Refresh',
  LOGOUT: 'Logout',
  BACK: 'Back',
};

export const headerTitle = 'HyP Parking Management Dashboard';
export const totalParkingCardTitle = 'Car Parking Occupancy (Total)';
export const levelwiseParkingCardTitle = 'Parking Occupancy (Level-wise)';
export const downloadReportTitle = 'Download report';
export const footerText =
  'HyP- Host your parking ©2023 Techprom IoT Solutions Pvt Ltd';
export const comingSoonCardTitle = 'Coming Soon';
export const parkingLevelSubtitle = 'Parking Level';
export const currentUtilization = 'Current Utilization';
export const pickReportFormatLabel = 'Pick the format of report';
export const availableParkingsLabel = 'Available Parkings';
export const pickDateLabel = 'Pick date';
export const pickDateYearLabel = 'Pick month and year';
